import { DealernetApi } from "./DealernetApi";

export class OrderService {
  static GetRecentOrderActivity(recentOrderActivityRequest) {
    return DealernetApi.client().post(
      "Orders/RecentOrderActivity",
      recentOrderActivityRequest
    );
  }

  static GetOrderDetails(
    accountId,
    userId,
    orderNumber,
    orderSource,
    dealerCode,
    salesOrg
  ) {
    return DealernetApi.client().get("Orders/OrderDetails", {
      params: {
        AccountId: accountId,
        UserId: userId,
        OrderNumber: orderNumber,
        OrderSource: orderSource,
        DealerCode: dealerCode,
        SalesOrg: salesOrg
      }
    });
  }

  static SearchOrdersByDocumentOrPart(
    AccountId,
    UserId,
    PartNumber,
    DocumentNumber,
    DealerCodes
  ) {
    return DealernetApi.client().post("Orders/SearchOrdersByDocumentOrPart", {
      AccountId,
      UserId,
      PartNumber,
      DocumentNumber,
      DealerCodes
    });
  }

  static getDownloadOfflineOrdersAction(){
    return window.appGlobals.API_URL + "Orders/DownloadRecentOfflineOrders";
  }

}
